import Model from '@/models/Model'

export default class AccAccountingSeat extends Model {
    resource() {
        return 'acc_accounting_seat'
    }

    static includes = [
        'g_generator_user.hr_employee',
        'acc_accounting_seat_status',
        'acc_accounting_seat_concept',
        'acc_accounting_seat_type',
    ]

    get generatorUserName() {
        return this.g_generator_user && this.g_generator_user.hr_employee
            ? this.g_generator_user.hr_employee.name_case
            : null
    }

    get balance() {
        let { debit_sum, credit_sum } = this
        if (debit_sum > credit_sum) {
            return debit_sum
        }
        if (debit_sum < credit_sum) {
            return credit_sum
        } else {
            return debit_sum
        }
    }

    get accountingSeatStatus() {
        return this.acc_accounting_seat_status
            ? this.acc_accounting_seat_status.status
            : null
    }
}
